import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/core/map/map.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/traversal/index/index.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/dimensions/position/position.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import error from "./error.js";

export default obj => {

	// preload all the screen containers and set aria properties
	const screens = obj.map((i, item) => $(item).next()),
		aria = (obj, current) => obj.attr("aria-hidden", i => i !== current).attr("aria-current", i => i === current);
	let current = obj.index(":checked");

	obj.on("change", function () {

		// set variables
		let updated = true,
			container = current > -1 ? $(screens[current]) : null,
			msg,
			errorclass = "hashform__control--error",
			next = obj.index(this);

		// look at each control and check validity
		if (current > -1 && next > current) {
			$("input,textarea,select", container).each(function () {
				const input = $(this);
				if (!this.reportValidity()) {
					input.addClass(errorclass);

					// reset back to the current page, as the event is not cancellable
					obj.eq(current).prop("checked", true);
					
					updated = false;

					// add error message
					if (!msg) {
						msg = input.data("error");
					}
				} else {
					input.removeClass(errorclass);
				}
			});
		}

		// update the current tab
		if (updated) {
			current = next;
			window.scroll({
				top: $(screens[current]).position().top,
				behavior: "smooth" // Optional for smooth scrolling
			});
		}
		error(container, msg);
		aria(screens, current);
	});

	// set aria tags if we are on a screen
	if (current > -1) {
		aria(screens, current);

	// switch to the first screen
	} else {
		obj.eq(0).prop("checked", true).trigger("change");
	}
};